import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { articles } from "@/data/articles";

const accentMap = {
    brand: "bg-brand-500",
    pinky: "bg-pinky-500",
    ink: "bg-ink-800",
};

export default function ArticlesIndex() {
    return (
        <div className="min-h-screen bg-white text-ink-900">
            <Navbar />
            <main className="pt-32 pb-20">
                <div className="container-wide">
                    <div className="max-w-2xl">
                        <span className="eyebrow-brand">Ressources gratuites</span>
                        <h1 data-testid="articles-index-title" className="display-1 mt-4">
                            Tips &amp; <span className="text-brand-500">Articles</span>.
                        </h1>
                        <p className="body-lg mt-6">
                            Des conseils pratiques basés sur notre méthodologie neuro-stoïcienne pour
                            commencer à agir dès aujourd'hui.
                        </p>
                    </div>

                    <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {articles.map((a) => (
                            <Link
                                to={`/articles/${a.slug}`}
                                key={a.slug}
                                data-testid={`article-card-${a.slug}`}
                                className="group soft-card overflow-hidden transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(15,23,42,0.25)]"
                            >
                                <div className="relative aspect-[5/4] overflow-hidden">
                                    <img
                                        src={a.img}
                                        alt={a.title}
                                        className="w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-[1.06]"
                                    />
                                    <span
                                        className={`absolute top-5 left-5 inline-block text-[10px] font-semibold uppercase tracking-[0.18em] ${accentMap[a.accent]} text-white px-3 py-1.5 rounded-full`}
                                    >
                                        {a.category}
                                    </span>
                                </div>
                                <div className="p-7 sm:p-8">
                                    <h2 className="font-display font-semibold text-xl text-ink-900 leading-snug">
                                        {a.title}
                                    </h2>
                                    <p className="mt-3 text-ink-600 leading-relaxed text-sm">
                                        {a.excerpt}
                                    </p>
                                    <div className="mt-6 flex items-center justify-between">
                                        <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-wider text-ink-500">
                                            <Clock className="h-3.5 w-3.5" strokeWidth={2} /> {a.readTime}
                                        </span>
                                        <span className="grid place-items-center h-9 w-9 rounded-full border border-ink-200 bg-white text-ink-700 transition-colors group-hover:bg-brand-500 group-hover:text-white group-hover:border-brand-500">
                                            <ArrowRight className="h-4 w-4" strokeWidth={2} />
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
